import CloseButton from "../../../components/CloseButton";
import { useContext } from 'react';
import ShopContext from "^/ShopContext";
const BrandFilter = (props) => {

  const {
    each,
  } = props;
  const count = '';

  const {
    selectedFilters,
    addRemoveSelectedFilter
  } = useContext(ShopContext);

  const name = 'brands';
  const isSelected = selectedFilters[name] ? selectedFilters[name][each.name] : false;

  
  if (!each.name) return <></>


  return (
    <li class="navList-item ss-list-option">
      <a
        onClick={() => addRemoveSelectedFilter({name, description: each.name }, isSelected ? 'remove': undefined)}
        class={"navList-action navList-action--checkbox filter-item" + (isSelected ? ' is-selected':'')}>{each.name}
        {/* <span > ({count})</span> */}
        <span class="navList-action-close" aria-hidden="true">
          <CloseButton />
        </span>
      </a>
    </li>

  )
}
export default BrandFilter;